import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.output.css';
import App from './App';

// Register service worker for PWA capabilities
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.log('Service Worker registration failed:', err);
    });
  });
}

// Enable smooth scrolling
document.documentElement.style.scrollBehavior = 'smooth';

// Prevent default pull-to-refresh on mobile
document.body.addEventListener('touchmove', function(e) {
  if (!e.target.closest('.smooth-scroll')) {
    e.preventDefault();
  }
}, { passive: false });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enable hot module replacement in development
if (module.hot) {
  module.hot.accept();
}